import React, { useEffect, useRef, useState } from "react";

const PopoutUtilityToolbarGrid = ({ 
	visible, 
	anchor = { x: 0, y: 0 }, 
	category = "attacker",
	onSelect, 
	onClose 
}) => {
	const [icons, setIcons] = useState([]);
	const [hoveredIndex, setHoveredIndex] = useState(null);
	const gridRef = useRef(null);

	// Extract friendly name from file path
	const getIconName = (src) => {
		const filename = src.split("/").pop(); // get last part of path
		return filename.replace(/\.[^.]+$/, "").replace(/-/g, " ");
	};

	// Load icons for the selected category
	useEffect(() => {
		const categoryPaths = {
			attacker: [
				"Ace", "Amaru", "Ash", "Blackbeard", "Blitz", "Brava", "Buck",
				"Capitao-Fire", "Capitao-Smoke", "Deimos", "Dokkaebi", "Finka", "Flores", "Fuze", "Glaz",
				"Gridlock", "Grim", "Hibana-2", "Hibana-4", "Hibana-6", "IQ", "Iana", "Jackal", 
				"Kali", "Lion", "Maverick", "Montagne", "Nokk", "Nomad", "Osa", "Ram", "Rauora",
				"Sens", "Sledge", "SolidSnake", "Thatcher", "Thermite", "Twitch", "Ying", "Zero", 
				"Zofia-Impact", "Zofia-Stun"
			],
			defender: [
				"Alibi", "Arumi", "Azami", "Bandit", "Castle", "Cav", "Clash", "Denari",
				"Doc", "Echo", "Ela", "Fenrir", "Frost", "Goyo", "Jaeger", "Kaid",
				"Kapkan", "Lesion", "Maestro", "Melusi", "Mira", "Mozzie", "Mute", "Noor",
				"Oryx", "Pulse", "Rook", "Skopos", "Smoke", "Solis", "Tachanka",
				"Thorn", "Thunderbird", "Tubarao", "Valkryie", "Vigil", "Wamai", "Warden"
			],
			utility: [
				"Barbed-Wire", "Barricade", "Breach-Charge", "Bulletproof-Camera", "Claymore", 
				"Deployable-Shield", "Drone", "Emp-Impact-Grenade", "Frag-Grenade", "Impact-Grenade", "Nitro-Cell", 
				"Observation-Blocker", "Proximity-Alarm", "Reinforcement", "Secondary-Breacher", "Smoke-Grenade", 
				"Stun-Grenade", "Head-Hole", "Foot-Hole", "Rotate-Hole", "Vertical-Hole",
			],
      
		};

		const names = categoryPaths[category] || [];
		const paths = names.map(name =>
			`/icons/r6s/utility/${category}/${name}.png`
		);

		setIcons(paths);
	}, [category]);

	// Close on outside click
	useEffect(() => {
		if (!visible) return;

		const handleClickOutside = (e) => {
			if (gridRef.current && !gridRef.current.contains(e.target)) {
				onClose();
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, [visible, onClose]);

	if (!visible) return null;

	const containerStyle = {
		position: "fixed",
		bottom: window.innerHeight - anchor.y + 8,
		left: anchor.x,
		backgroundColor: "#222",
		border: "1px solid #444",
		borderRadius: "4px",
		boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
		zIndex: 1000,
		padding: 8,
	};

	const gridStyle = {
		display: "grid",
		gridTemplateColumns: "repeat(10, 48px)",
		gap: 8,
	};

	const itemStyle = {
		width: 48,
		height: 48,
		borderRadius: 4,
		overflow: "visible",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		cursor: "pointer",
		background: "#111",
		border: "1px solid #333",
		transition: "all 0.2s ease",
		position: "relative",
	};

	return (
		<div ref={gridRef} style={containerStyle} role="dialog" aria-hidden={!visible}>
			<div style={gridStyle}>
				{icons.map((src, i) => (
					<div
						key={src + i}
						style={itemStyle}
						draggable
						onDragStart={(e) => {
							e.dataTransfer.effectAllowed = "copy";
							e.dataTransfer.setData("application/json", JSON.stringify({ type: "utility", src }));
						}}
						onClick={() => {
							onSelect && onSelect(src);
							onClose();
						}}
						onMouseEnter={(e) => {
							e.currentTarget.style.border = "1px solid #0af";
							e.currentTarget.style.background = "#1a3a3a";
							setHoveredIndex(i);
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.border = "1px solid #333";
							e.currentTarget.style.background = "#111";
							setHoveredIndex(null);
						}}
					>
						<img
							src={src}
							alt="utility"
							style={{ width: 50, height: 50, objectFit: "contain", pointerEvents: "none" }}
							loading="lazy"
						/>
						{hoveredIndex === i && (
							<div
								style={{
									position: "absolute",
									bottom: "100%",
									left: "50%",
									transform: "translateX(-50%)",
									marginBottom: 6,
									backgroundColor: "#000",
									color: "#FFFFFF",
									padding: "4px 8px",
									fontSize: 12,
									whiteSpace: "nowrap",
									pointerEvents: "none",
									zIndex: 1001,
								}}
							>
								{getIconName(src)}
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default PopoutUtilityToolbarGrid;
